
export default defineNuxtPlugin((nuxtApp) => {
  const { reloadToLatestDeployment, clearDeploymentIdCookie } = useSkewProtection()

  // Try to remove the deployment ID cookie on browser reload to get the latest deployment
  window.addEventListener('beforeunload', clearDeploymentIdCookie)

  // Reload on chunkError
  nuxtApp.hook('app:chunkError', (e) => {
    console.info('ChunkError reload', e)

    try {
      reloadToLatestDeployment()
    } catch {
      //
    }
  })
})